export const isOfType = <T>(
  varToBeChecked: any,
  propertyKey: keyof T,
  propertyValue: T[keyof T],
): varToBeChecked is T => (varToBeChecked as T)[propertyKey] === propertyValue
